import React, { useState } from 'react';
import ChatList from './ChatList';
import { ScrollPanel } from 'primereact/scrollpanel';

const ChatListContainer = ({ chatData, selectedChat, handleChatClick }) => {
  

  return (
    <div className="md:w-25rem card p-0">
      <div className='flex flex-column align-items-center border-bottom-1 surface-border p-6 mb-2'>
        <span>
          <i className="pi pi-comments"></i> Customer Support
        </span>
      </div>

      <ScrollPanel style={{ width: '100%', height: '500px', paddingBottom: '20px' }}>
        {chatData.map((chat, index) => (
          <ChatList
            key={index}
            senderOnlineStatus={chat.senderOnlineStatus}
            senderImage={chat.senderImage}
            senderName={chat.senderName}
            message={chat.message}
            lastSeen={chat.lastSeen}
            isSelected={selectedChat === index}
            onClick={() => handleChatClick(index)}
          />
        ))}
      </ScrollPanel>
    </div>
  );
};

export default ChatListContainer;
